import React from 'react';
import { GraduationCap, User, TrendingUp, Award, Calendar, BarChart2 } from 'lucide-react';
import { RoadmapTier } from './RoadmapTier';
import { motion } from 'framer-motion';
export function Roadmap() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.3
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6" data-id="element-851" data-mp="14um0tsi1iz3s">
      <div className="bg-gray-50 border-b border-gray-200 px-6 py-4" data-id="element-852" data-mp="qv2un58shxu4">
        <h2 className="text-xl font-extrabold text-[#0a1e5e] flex items-center gap-2" data-id="element-853" data-mp="lwsxwq7f2p6e">
          <TrendingUp className="w-6 h-6 text-blue-600" data-id="element-854" data-mp="gxy7p374dyc9" />
          LOAN ORIGINATOR ROADMAP
        </h2>
      </div>

      <div className="px-6 pt-8 pb-6 overflow-x-auto" data-id="element-855" data-mp="2gbltwqc7phyv">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-6 gap-y-10 min-w-[1000px]" data-id="element-856" data-mp="2gaaokm34c25n">
          {/* Tier 1 */}
          <RoadmapTier number={1} title="LOAN PARTNER" subtitle="(Developmental) 0-6 Months" icon={<GraduationCap className="w-6 h-6" data-id="element-858" data-mp="2o6z7u7s818ur" />} colorClass="text-blue-500" bgHeaderClass="bg-blue-400" requirements={<div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-859" data-mp="2f586tg8mlq78">
                <div className="w-5 h-5 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center shrink-0" data-id="element-860" data-mp="2f72q6q491a97">
                  <span className="text-xs font-bold" data-id="element-861" data-mp="37uf3sasfm7qd">✓</span>
                </div>
                Pass and Study for NMLS Safe Exam
              </div>} focusItems={['Learn systems and processes', 'Support Loan Officers', 'Understand loan products']} compTiers={[{
          units: 'Base',
          bps: 60
        }, {
          units: '4+ Units',
          bps: 65,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 80,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 90,
          bonus: 30
        }]} goal="GET LICENSED" goalSub="& START CLOSING" data-id="element-857" data-mp="2k4ch6a7adtz5" />

          {/* Tier 2 - Current */}
          <RoadmapTier number={2} title="LOAN OFFICER" icon={<User className="w-6 h-6" data-id="element-863" data-mp="3cpriu637sx0r" />} isActive={true} colorClass="text-blue-600" bgHeaderClass="bg-blue-600" requirements={<ul className="space-y-1.5" data-id="element-864" data-mp="32t4zxmug8g1d">
                <li className="flex items-center gap-2 text-xs font-medium text-gray-700" data-id="element-865" data-mp="32ug4hovpxrtj">
                  <div className="w-4 h-4 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0 text-[10px]" data-id="element-866" data-mp="2yqi4zd2heezy">
                    ✓
                  </div>
                  Pass Safe Exam
                </li>
                <li className="flex items-center gap-2 text-xs font-medium text-gray-700" data-id="element-867" data-mp="19c8ov8hldym8">
                  <div className="w-4 h-4 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0 text-[10px]" data-id="element-868" data-mp="1eatszizyt2fy">
                    ✓
                  </div>
                  Complete State Education
                </li>
                <li className="flex items-center gap-2 text-xs font-medium text-gray-700" data-id="element-869" data-mp="qk7m3v1p5o7j">
                  <div className="w-4 h-4 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0 text-[10px]" data-id="element-870" data-mp="uki280j7dv04">
                    ✓
                  </div>
                  Obtain Required Licenses
                </li>
              </ul>} focusItems={['Build Your Pipeline', 'Increase Conversions', 'Consistent Closings']} compTiers={[{
          units: 'Base',
          bps: 80
        }, {
          units: '4+ Units',
          bps: 85,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 100,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 110,
          bonus: 30
        }]} goal="BUILD YOUR PIPELINE." goalSub="CLOSE LOANS. GROW CONSISTENTLY." data-id="element-862" data-mp="3hj3w5k2g1he7" />

          {/* Tier 3 - Next */}
          <RoadmapTier number={3} title="SENIOR LOAN OFFICER" icon={<TrendingUp className="w-6 h-6" data-id="element-872" data-mp="367k4n7rg57t7" />} isNext={true} colorClass="text-[#0a1e5e]" bgHeaderClass="bg-[#0a1e5e]" requirements={<div className="flex items-center justify-between gap-2" data-id="element-873" data-mp="1buubwtcte4ne">
                <div className="flex flex-col items-center text-center flex-1" data-id="element-874" data-mp="17tikciadr9ck">
                  <Calendar className="w-6 h-6 text-[#0a1e5e] mb-1" data-id="element-875" data-mp="xp26fuggo2be" />
                  <span className="text-xs font-bold text-[#0a1e5e] leading-tight" data-id="element-876" data-mp="xqwnuysixcaq">
                    2 YEARS
                    <br data-id="element-877" data-mp="nz0gex4js9tu" />
                    TENURE
                  </span>
                </div>
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-bold text-gray-500 shrink-0" data-id="element-878" data-mp="sy3luiofwi2c">
                  OR
                </div>
                <div className="flex flex-col items-center text-center flex-1" data-id="element-879" data-mp="e35spnlgvok7">
                  <BarChart2 className="w-6 h-6 text-[#0a1e5e] mb-1" data-id="element-880" data-mp="j17a8438vftk" />
                  <span className="text-xs font-bold text-[#0a1e5e] leading-tight" data-id="element-881" data-mp="5168ynj2i6dk">
                    16 UNITS
                    <br data-id="element-882" data-mp="a00uhx8f691d" />
                    <span className="text-[9px] font-medium" data-id="element-883" data-mp="a1bwpsm7v8qd">IN ANY 4 MO</span>
                  </span>
                </div>
              </div>} focusItems={['Consistent High Production', 'Strong Pipeline Management', 'Advanced Deal Structuring', 'Maximize Efficiency & Results']} compTiers={[{
          units: 'Base',
          bps: 85
        }, {
          units: '4+ Units',
          bps: 90,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 105,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 115,
          bonus: 30
        }]} goal="ELEVATE YOUR PRODUCTION." goalSub="LEAD BY EXAMPLE." data-id="element-871" data-mp="2saokok9npvyd" />

          {/* Tier 4 */}
          <RoadmapTier number={4} title="EXECUTIVE LOAN OFFICER" icon={<Award className="w-6 h-6" data-id="element-885" data-mp="34ene7abci7sk" />} colorClass="text-orange-500" bgHeaderClass="bg-orange-500" requirements={<div className="flex items-center justify-between gap-2" data-id="element-886" data-mp="36y0ewr07lqvq">
                <div className="flex flex-col items-center text-center flex-1" data-id="element-887" data-mp="36zuzu5bhdizt">
                  <Calendar className="w-6 h-6 text-orange-500 mb-1" data-id="element-888" data-mp="3byo5jbkj05pf" />
                  <span className="text-xs font-bold text-orange-500 leading-tight" data-id="element-889" data-mp="3guveld87xxbl">
                    1 YEAR
                    <br data-id="element-890" data-mp="3lwccr0zbj5oh" />
                    <span className="text-[9px] font-medium" data-id="element-891" data-mp="3lses2ax3e62h">AS SENIOR LO</span>
                  </span>
                </div>
                <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-[10px] font-bold text-orange-600 shrink-0" data-id="element-892" data-mp="3uv6349m22ztl">
                  AND
                </div>
                <div className="flex flex-col items-center text-center flex-1" data-id="element-893" data-mp="8flh6if9xga5">
                  <BarChart2 className="w-6 h-6 text-orange-500 mb-1" data-id="element-894" data-mp="8hpgen289r43" />
                  <span className="text-xs font-bold text-orange-500 leading-tight" data-id="element-895" data-mp="dgitiedlrg3q">
                    26 UNITS
                    <br data-id="element-896" data-mp="hegnrvm8csdz" />
                    <span className="text-[9px] font-medium" data-id="element-897" data-mp="12r82cc1vuimx">IN ANY 6 MO</span>
                  </span>
                </div>
              </div>} focusItems={['Elite Level Production', 'Drive Results', 'High-Level Relationships', 'Operate at the Highest Level']} compTiers={[{
          units: 'Base',
          bps: 90
        }, {
          units: '4+ Units',
          bps: 95,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 110,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 120,
          bonus: 30
        }]} goal="DOMINATE YOUR MARKET." goalSub="BUILD A LASTING LEGACY." data-id="element-884" data-mp="26xeufzwqwh55" />
        </div>
      </div>
    </motion.div>;
}